import { useReducedMotion, Variants } from 'motion/react';

const ENTER_TRANSITION = { duration: 0.32, ease: [0.22, 1, 0.36, 1] as const };
const EXIT_TRANSITION = { duration: 0.2, ease: [0.4, 0, 1, 1] as const };

// Exiting questions ignore clicks; centered ones inherit the container's loading guard
const buildQuestionVariants = (offset: number): Variants => ({
  enter: (isForward: boolean) => ({
    opacity: 0,
    x: isForward ? offset : -offset,
  }),
  center: {
    opacity: 1,
    x: 0,
    pointerEvents: 'inherit',
    transition: ENTER_TRANSITION,
  },
  exit: (isForward: boolean) => ({
    opacity: 0,
    x: isForward ? -offset : offset,
    pointerEvents: 'none',
    transition: EXIT_TRANSITION,
  }),
});

const DESKTOP_VARIANTS = buildQuestionVariants(16);
const MOBILE_VARIANTS = buildQuestionVariants(40);
const REDUCED_MOTION_VARIANTS: Variants = {
  enter: { opacity: 0 },
  center: {
    opacity: 1,
    pointerEvents: 'inherit',
    transition: { duration: 0.15 },
  },
  exit: {
    opacity: 0,
    pointerEvents: 'none',
    transition: { ...EXIT_TRANSITION, duration: 0.15 },
  },
};

export const useQuestionTransitionVariants = (isMobile: boolean): Variants => {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) return REDUCED_MOTION_VARIANTS;
  return isMobile ? MOBILE_VARIANTS : DESKTOP_VARIANTS;
};
